import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import GameDetail from "./pages/GameDetail";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Profile from "./pages/Profile";
import Wishlist from "./pages/Wishlist";
import Trending from "./pages/Trending";
import About from "./pages/About";


function App() {
  const [mode, setMode] = useState(() => localStorage.getItem("mode") || "dark");

  useEffect(() => {
    document.body.setAttribute("data-theme", mode);
    localStorage.setItem("mode", mode);
  }, [mode]);

  return (
    <>
      <Navbar mode={mode} setMode={setMode} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/games/:id" element={<GameDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/trending" element={<Trending />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </>
  );
}

export default App;
